import { API_BASE_URL } from "@/config";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { validateToken } from '@/utils/auth';
import OCRComponent from "@/components/ocr_component/OCRComponent.vue";


export default {
  name: 'OcrDocumentReader',
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  props: {
    photo: {
      type: String,
      required: false
    }
  },
  components: {
    OCRComponent
  },
  data() {
    return {
      document_list: [],
      transaction_id: null,
      first_name: '',
      last_name: '',
      submitting_data: false,
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    handleDocumentProcessed(data) {
      if (data.documentList) {
        this.document_list = data.documentList;
      }
      else if (data.transactionId) {
        this.transaction_id = data.transactionId;
      }
      this.submitting_data = true;
      this.document_verification();
    },
    handleScanStarted() {
      // Scroll to top with smooth animation
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      
      // Also scroll document elements smoothly
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Use setTimeout to ensure DOM is ready, then hide overflow
      setTimeout(() => {
        // Find and hide overflow on the container-fluid
        const containers = document.querySelectorAll('.container-fluid');
        containers.forEach(container => {
          container.style.overflow = 'hidden';
          container.scrollTop = 0;
        });
        
        // Hide on body and html
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }, 600); // Wait for smooth scroll to complete
    },
    document_verification() {
      const TOKEN = localStorage.getItem("token");
      const SAFPS_URL = `${API_BASE_URL}/verify_api/personnel_verification/ocr_liveness_verification/`;
      
      var form_data = {
        workflow_id: this.workflow_id,
        liveness_photo: this.photo
      };

      if (this.first_name && this.last_name) {
        form_data['firstnames'] = this.first_name;
        form_data['lastname'] = this.last_name;
      }

      if (this.document_list) {
         form_data['document_list'] = this.document_list;
      }
      else if (this.transaction_id) {
        form_data['transaction_id'] = this.transaction_id;
      }
      else {
        Swal.fire({
          icon: "error",
          text: "No document or transaction ID found. Please try again.",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
        return;
      }
      
      $.ajax({
        url: SAFPS_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(form_data),
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          const status_message = response.status;
          if (status_message === "success") {
            Swal.fire({
              icon: "success",
              text: "Liveness verification successful",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              allowOutsideClick: false
            }).then(() => {
              this.fetch_current_service();
            });
          } else if (status_message === "error") {
            // Get more detailed error message from response
            let detailed_message = "Could not read document, please provide a valid document and try again";
            if (response.message) {
              detailed_message = response.message;
            } else if (response.data && typeof response.data === 'string') {
              detailed_message = response.data;
            }

            Swal.fire({
              icon: "error",
              title: "Document Processing Failed",
              text: detailed_message,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
          else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "An unexpected error occurred. Please try again.";
          let error_title = "Error";
          if (error.responseJSON) {
            if (error.responseJSON.message) {
              error_message = error.responseJSON.message;

              if (error_message.includes('liveness')) {
                error_title = "Liveness Verification Failed";
              } else if (error_message.includes('document') || error_message.includes('OCR')) {
                error_title = "Document Processing Failed";
              } else if (error_message.includes('face') || error_message.includes('comparison')) {
                error_title = "Face Verification Failed";
              }

            } else if (error.responseJSON.data) {
              error_message = typeof error.responseJSON.data === 'string' ?
                error.responseJSON.data :
                "Please check your document and photo quality, then try again.";

              if (error_message.includes('liveness') || error_message.includes('screen')) {
                error_title = "Photo Quality Issue";
                error_message = "Please take a clear, live photo without using a screen.";
              }
            } else if (error.responseJSON.id_number && error.responseJSON.id_number[0]) {
              error_message = error.responseJSON.id_number[0];
              error_title = "Validation Error";
            }
          }

          Swal.fire({
            icon: "error",
            title: error_title,
            text: error_message,
            confirmButtonText: "Try Again"
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        },
      });
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
        return;
    }
    this.get_customer_data();
  },
};
